var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { combineReducers } from 'redux';
import { countryInfoReducer } from './countryinfo';
import { countryInnerPageReducer } from './countryInnerPage';
import { setCreatorReducer } from './creator';
import { uploadFileReducer } from './uploadFile';
import { longreadBlocksReducer } from './longreadBlocks';
import { innerpageBlocksReducer } from './innerpageBlocks';
import { userInfoFPReducer } from './getUserFP';
import { getIndustryImage } from './getIndustryImage';
import { setEditLongReadReducer } from './setEditLongRead';
import { addLongReadPostReducer } from './addLongReadPost';
import { getLongReadPostsReducer } from './getLongReadPosts';
import { getLongReadReducer } from './getLongRead';
import { updateLongReadPostReducer } from './updateLongReadPost';
import { toggleLongReadPostUpdate } from './toggleLongReadPostUpdate';
import { getDoiserStates } from './getDoiserStates';
import { getThematics } from './getThematics';
import { getThematicContent } from './getThematicContent';
import { getDoiser } from './getDoiser';
import { createPrefix } from './createPrefix';
import { getOverlayData } from './overlayReducer';
import { updateLongReadPositionReducer } from './updateLongReadPosition';
import { deleteLongReadPostReducer } from './deleteLongReadPost';
import { setPostViewType } from './setPostViewType';
import { authXSliceReducer } from '@brg/auth';
import { modalControllerReduces } from '../core/modules/modal.module';
import { widePreviewerReducer } from './toggleWidePreviewer';
import { getVoteEntityId } from './getVoteEntityId';
import { getVoteWinner } from './getVoteWinner';
import { homeworkReducer } from './homework';
import { getLMSInfoReducer } from './getLMSInfo';
import { sortRaitingReducer } from './sortRaiting';
import { fullScreenReducer } from './fullScreenReducer';
import { chatReducer } from './chatReducer';
var combineReducersLR = function (reducers) {
    return function (state, action) {
        if (state === void 0) { state = {}; }
        return Object.keys(reducers).reduce(function (nextState, key) {
            nextState[key] = reducers[key](state[key], action);
            return nextState;
        }, {});
    };
};
export var rootReducerLR = function (mode) {
    return combineReducersLR(__assign(__assign({ longreadBlocks: longreadBlocksReducer, countryInfo: countryInfoReducer, countryInnerPage: countryInnerPageReducer, creatorOptions: setCreatorReducer, file: uploadFileReducer, innerpageBlocks: innerpageBlocksReducer, userinfoFP: userInfoFPReducer, industryImage: getIndustryImage, editLongRead: setEditLongReadReducer, getLMSInfo: getLMSInfoReducer, addlgpost: addLongReadPostReducer, deletelgpost: deleteLongReadPostReducer, updatelgpost: updateLongReadPostReducer, toggleWidePreviewer: widePreviewerReducer, longreadinfo: getLongReadReducer, longreadposts: getLongReadPostsReducer, updateLongReadPositionReducer: updateLongReadPositionReducer, toggleLongReadPostUpdate: toggleLongReadPostUpdate, doiserStates: getDoiserStates, thematics: getThematics, thematicContent: getThematicContent, dosier: getDoiser, prefixData: createPrefix, getOverlayData: getOverlayData, postType: setPostViewType }, (mode === 'development' ? { authX: authXSliceReducer } : {})), { modalController: modalControllerReduces, voteEntity: getVoteEntityId, voteWinner: getVoteWinner, homework: homeworkReducer, rSorting: sortRaitingReducer, fullScreen: fullScreenReducer, chat: chatReducer }));
};
/*


    longreadBlocks: longreadBlocksReducer,
    countryInfo: countryInfoReducer,
    countryListByCoordinate: countryListByCoordinateReducer,
    countryInnerPage: countryInnerPageReducer,
    creatorOptions: setCreatorReducer,
    file: uploadFileReducer,
    innerpageBlocks: innerpageBlocksReducer,
    userinfoFP: userInfoFPReducer,
    industryImage: getIndustryImage,
    editLongRead: setEditLongReadReducer,
    addlgpost: addLongReadPostReducer,
    deletelgpost: deleteLongReadPostReducer,
    updatelgpost: updateLongReadPostReducer,
    longreadinfo: getLongReadReducer,
    longreadposts: getLongReadPostsReducer,
    updateLongReadPositionReducer: updateLongReadPositionReducer,
    toggleLongReadPostUpdate: toggleLongReadPostUpdate,
    doiserStates: getDoiserStates,
    thematics: getThematics,
    dosier: getDoiser,
    prefixData: createPrefix,
    getOverlayData: getOverlayData

    countryInfo: countryInfoReducer,
    initmobmap: initMobileMapReducer,
    mapView: mapViewReducer,
    mapMode: mapModeReducer,
    countryListByCoordinate: countryListByCoordinateReducer,
    countryInnerPage: countryInnerPageReducer,
    creatorOptions: setCreatorReducer,
    meridian: changeMeridianReducer,
    file: uploadFileReducer,
    longreadBlocks: longreadBlocksReducer,
    innerpageBlocks: innerpageBlocksReducer,
    userinfoFP: userInfoFPReducer,
    industryImage: getIndustryImage,
    editLongRead: setEditLongReadReducer,
    addlgpost: addLongReadPostReducer,
    updatelgpost: updateLongReadPostReducer,
    longreadinfo: getLongReadReducer,
    longreadposts: getLongReadPostsReducer,
    toggleLongReadPostUpdate: toggleLongReadPostUpdate,
    doiserStates: getDoiserStates,
    thematics: getThematics,
    dosier: getDoiser,
    prefixData: createPrefix
*/
//# sourceMappingURL=index.js.mapvar __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { combineReducers } from 'redux';
import { countryInfoReducer } from './countryinfo';
import { countryInnerPageReducer } from './countryInnerPage';
import { setCreatorReducer } from './creator';
import { uploadFileReducer } from './uploadFile';
import { longreadBlocksReducer } from './longreadBlocks';
import { innerpageBlocksReducer } from './innerpageBlocks';
import { userInfoFPReducer } from './getUserFP';
import { getIndustryImage } from './getIndustryImage';
import { setEditLongReadReducer } from './setEditLongRead';
import { addLongReadPostReducer } from './addLongReadPost';
import { getLongReadPostsReducer } from './getLongReadPosts';
import { getLongReadReducer } from './getLongRead';
import { updateLongReadPostReducer } from './updateLongReadPost';
import { toggleLongReadPostUpdate } from './toggleLongReadPostUpdate';
import { getDoiserStates } from './getDoiserStates';
import { getThematics } from './getThematics';
import { getThematicContent } from './getThematicContent';
import { getDoiser } from './getDoiser';
import { createPrefix } from './createPrefix';
import { getOverlayData } from './overlayReducer';
import { updateLongReadPositionReducer } from './updateLongReadPosition';
import { deleteLongReadPostReducer } from './deleteLongReadPost';
import { setPostViewType } from './setPostViewType';
import { authXSliceReducer } from '@brg/auth';
import { modalControllerReduces } from '../core/modules/modal.module';
import { widePreviewerReducer } from './toggleWidePreviewer';
import { getVoteEntityId } from './getVoteEntityId';
import { getVoteWinner } from './getVoteWinner';
import { homeworkReducer } from './homework';
import { getLMSInfoReducer } from './getLMSInfo';
import { sortRaitingReducer } from './sortRaiting';
import { fullScreenReducer } from './fullScreenReducer';
import { chatReducer } from './chatReducer';
var combineReducersLR = function (reducers) {
    return function (state, action) {
        if (state === void 0) { state = {}; }
        return Object.keys(reducers).reduce(function (nextState, key) {
            nextState[key] = reducers[key](state[key], action);
            return nextState;
        }, {});
    };
};
export var rootReducerLR = function (mode) {
    return combineReducersLR(__assign(__assign({ longreadBlocks: longreadBlocksReducer, countryInfo: countryInfoReducer, countryInnerPage: countryInnerPageReducer, creatorOptions: setCreatorReducer, file: uploadFileReducer, innerpageBlocks: innerpageBlocksReducer, userinfoFP: userInfoFPReducer, industryImage: getIndustryImage, editLongRead: setEditLongReadReducer, getLMSInfo: getLMSInfoReducer, addlgpost: addLongReadPostReducer, deletelgpost: deleteLongReadPostReducer, updatelgpost: updateLongReadPostReducer, toggleWidePreviewer: widePreviewerReducer, longreadinfo: getLongReadReducer, longreadposts: getLongReadPostsReducer, updateLongReadPositionReducer: updateLongReadPositionReducer, toggleLongReadPostUpdate: toggleLongReadPostUpdate, doiserStates: getDoiserStates, thematics: getThematics, thematicContent: getThematicContent, dosier: getDoiser, prefixData: createPrefix, getOverlayData: getOverlayData, postType: setPostViewType }, (mode === 'development' ? { authX: authXSliceReducer } : {})), { modalController: modalControllerReduces, voteEntity: getVoteEntityId, voteWinner: getVoteWinner, homework: homeworkReducer, rSorting: sortRaitingReducer, fullScreen: fullScreenReducer, chat: chatReducer }));
};
/*


    longreadBlocks: longreadBlocksReducer,
    countryInfo: countryInfoReducer,
    countryListByCoordinate: countryListByCoordinateReducer,
    countryInnerPage: countryInnerPageReducer,
    creatorOptions: setCreatorReducer,
    file: uploadFileReducer,
    innerpageBlocks: innerpageBlocksReducer,
    userinfoFP: userInfoFPReducer,
    industryImage: getIndustryImage,
    editLongRead: setEditLongReadReducer,
    addlgpost: addLongReadPostReducer,
    deletelgpost: deleteLongReadPostReducer,
    updatelgpost: updateLongReadPostReducer,
    longreadinfo: getLongReadReducer,
    longreadposts: getLongReadPostsReducer,
    updateLongReadPositionReducer: updateLongReadPositionReducer,
    toggleLongReadPostUpdate: toggleLongReadPostUpdate,
    doiserStates: getDoiserStates,
    thematics: getThematics,
    dosier: getDoiser,
    prefixData: createPrefix,
    getOverlayData: getOverlayData

    countryInfo: countryInfoReducer,
    initmobmap: initMobileMapReducer,
    mapView: mapViewReducer,
    mapMode: mapModeReducer,
    countryListByCoordinate: countryListByCoordinateReducer,
    countryInnerPage: countryInnerPageReducer,
    creatorOptions: setCreatorReducer,
    meridian: changeMeridianReducer,
    file: uploadFileReducer,
    longreadBlocks: longreadBlocksReducer,
    innerpageBlocks: innerpageBlocksReducer,
    userinfoFP: userInfoFPReducer,
    industryImage: getIndustryImage,
    editLongRead: setEditLongReadReducer,
    addlgpost: addLongReadPostReducer,
    updatelgpost: updateLongReadPostReducer,
    longreadinfo: getLongReadReducer,
    longreadposts: getLongReadPostsReducer,
    toggleLongReadPostUpdate: toggleLongReadPostUpdate,
    doiserStates: getDoiserStates,
    thematics: getThematics,
    dosier: getDoiser,
    prefixData: createPrefix
*/
//# sourceMappingURL=index.js.map